module.exports = __webpack_public_path__ + "img/emoji_048.62c223f7.png";